import PropTypes from 'prop-types';
import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import useUser from 'utils/useUser';

import ProfileMenuIcon from 'components/atoms/icons/profileMenuIcon';
import ProfileIcon from 'components/atoms/icons/profileIcon';
import { useAuth0 } from '@auth0/auth0-react';
import { PLATFORM_CONFIG } from 'utils/accessManager/constants';
import {
  isPractice,
  isAdmin,
  isPatient,
  isAgencyDoctor,
  agencyDoctorWithRPMAndCCMRoles,
} from 'utils/userTypeHelper';
import AwsIcon from 'components/atoms/icons/awsIcon';
import TelemedIcon from 'components/atoms/icons/telemedIcon';
import ReportBucketIcon from 'components/atoms/icons/reportBucketIcon';
import EditProfileIcon from 'components/atoms/icons/editProfileIcon';
import path from 'constants/paths';
import { isCriticalOrAtRiskAlertingRole } from 'utils/accessManager/helpers';
import Paths from '../../../constants/paths';

const NavbarProfileMenu = ({
  firstName,
  lastName,
  title,
  dataCy,
  limitedMenu,
}) => {
  const history = useHistory();
  const { userType, roleNames, platformMode } = useUser();
  const {
    user: { switchPlatformMode },
  } = useDispatch();
  const { logout } = useAuth0();

  const togglePlatformMode = () => {
    const newMode = switchPlatformMode({});
    history.push(PLATFORM_CONFIG[newMode].dashboard);
  };

  let nameString = '';
  if (title !== '' && firstName !== '' && lastName !== '') {
    nameString = `${title} ${firstName} ${lastName}`;
  }
  if (title === '' && firstName !== '' && lastName !== '') {
    nameString = `${firstName} ${lastName}`;
  }

  return (
    <UncontrolledDropdown nav inNavbar>
      <DropdownToggle nav className="navbar-dropdown-profile" data-cy={dataCy}>
        <ProfileMenuIcon />
      </DropdownToggle>
      <DropdownMenu right className="navbar-dropdown profile-menu">
        <DropdownItem className="navbar-dropdown-item profile-name">
          <ProfileIcon className="profile-name-icon" />
          <div>
            <div>{nameString}</div>
            <div className="profile-name-text">My profile</div>
          </div>
          {!isCriticalOrAtRiskAlertingRole(roleNames) && (
            <Link
              to={path.profile}
              className="profile-name-edit-icon"
              data-cy="nav-profile__edit"
            >
              <EditProfileIcon />
            </Link>
          )}
        </DropdownItem>
        {PLATFORM_CONFIG[platformMode].switch &&
          !limitedMenu &&
          (isPractice(userType) ||
            isAdmin(userType) ||
            agencyDoctorWithRPMAndCCMRoles(userType, roleNames)) && (
            <>
              <DropdownItem
                className="navbar-dropdown-item profile-item"
                data-cy="nav-profile__platform-mode"
                onClick={() => togglePlatformMode()}
              >
                <div className="navbar-dropdown-item__link">
                  <div className="navbar-dropdown-item__icon">
                    {PLATFORM_CONFIG[platformMode].icon}
                  </div>
                  <div className="navbar-dropdown-item__text">
                    {PLATFORM_CONFIG[platformMode].switch}
                  </div>
                </div>
              </DropdownItem>
              <div className="navbar-dropdown-item__decor" />
            </>
          )}
        {!isPatient(userType) && (
          <>
            <DropdownItem className="navbar-dropdown-item profile-item">
              <a
                href={Paths.telmed}
                data-cy="nav-profile__telemed"
                target="_blank"
                className="navbar-telemed navbar-dropdown-item__link"
              >
                <div className="navbar-dropdown-item__icon">
                  <TelemedIcon />
                </div>
                <div className="navbar-dropdown-item__text">Telemed</div>
              </a>
            </DropdownItem>
            <div className="navbar-dropdown-item__decor" />
            <DropdownItem className="navbar-dropdown-item profile-item">
              <a
                href={Paths.bucketReport}
                target="_blank"
                data-cy="nav-profile__bucket-report"
                className="navbar-report-bucket navbar-dropdown-item__link"
              >
                <div className="navbar-dropdown-item__icon">
                  <ReportBucketIcon />
                </div>
                <div className="navbar-dropdown-item__text">Files.com.</div>
              </a>
            </DropdownItem>
            <div className="navbar-dropdown-item__decor" />
          </>
        )}
        {(isAdmin(userType) || isAgencyDoctor(userType)) && !limitedMenu && (
          <>
            <DropdownItem className="navbar-dropdown-item profile-item">
              <a
                href={Paths.awsConnectURL}
                data-cy="nav-profile__aws-connect"
                target="_blank"
                className="navbar-aws-connect navbar-dropdown-item__link"
              >
                <div className="navbar-dropdown-item__icon">
                  <AwsIcon />
                </div>
                <div className="navbar-dropdown-item__text">Amazon connect</div>
              </a>
            </DropdownItem>
            <div className="navbar-dropdown-item__decor" />
          </>
        )}

        <DropdownItem
          className="navbar-dropdown-item profile-item"
          data-cy="nav-profile__logout"
          onClick={() => logout({ returnTo: window.location.origin })}
        >
          Logout
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

NavbarProfileMenu.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  title: PropTypes.string,
  dataCy: PropTypes.string,
  limitedMenu: PropTypes.bool,
};

export default NavbarProfileMenu;
